<template>
  <el-table
    class="mt-5"
    ref="priorOffer"
    empty-text="No Data"
    :fit="true"
    border
    :data="prior.show_list"
  >
    <el-table-column type="selection" width="55"></el-table-column>
    <el-table-column label="Offer" show-overflow-tooltip min-width="360px">
      <template slot-scope="scope">
        {{ '(' + scope.row.oid + ')' + scope.row.name }}
      </template>
    </el-table-column>
    <el-table-column prop="payout_price" label="Payout($)" min-width="150px"></el-table-column>
    <el-table-column label="Application Status" show-overflow-tooltip min-width="250px">
      <template slot-scope="scope">
        {{ getApproveStatus(scope.row.approve_status) }}
      </template>
    </el-table-column>
    <el-table-column label="Status" min-width="150px">
      <template slot-scope="scope">
        <span
          class="ym-dot mr-2"
          :class="scope.row.active_status || scope.row.status === 1 ? 'green' : 'red'"
        ></span>
        {{ scope.row.active_status || scope.row.status === 1 ? 'Active' : 'Paused' }}
      </template>
    </el-table-column>
    <el-table-column min-width="240px" v-if="type === 'weight'">
      <template slot="header">
        Weight Ratio(%)
        <el-tooltip
          enterable
          content="The algorithm sends the traffic according to preferred offer's weight. Suggest to set the below offer's weight between 1 and 100."
          placement="top"
        >
          <i class="icon-y-question"></i>
        </el-tooltip>
      </template>
      <template slot-scope="scope">
        <el-form-item class="ratio" :prop="String(scope.row.oid)" :rules="rules.ratio">
          <el-input
            placeholder="Input the weight(0<ratio<100)"
            v-model="offer_ratio[scope.row.oid]"
          ></el-input>
        </el-form-item>
      </template>
    </el-table-column>
    <el-table-column label="Action" min-width="280px" fixed="right">
      <template slot-scope="scope">
        <el-button
          class="long-button"
          type="warning"
          @click="moveOffer('prior', 'normal', '', { list: [scope.row] })"
        >
          Delete
        </el-button>
        <el-button
          class="long-button"
          @click="moveOffer('prior', 'blocked', '', { list: [scope.row] })"
          type="danger"
        >
          Block
        </el-button>
      </template>
    </el-table-column>
  </el-table>
</template>

<script>
export default {
  name: 'prior-offer',
  props: {
    prior: Object,
    moveOffer: Function,
    rules: Object,
    offer_ratio: Object,
    type: String,
  },
  data() {
    return {}
  },
  methods: {
    getApproveStatus(status) {
      return status === 0
        ? 'Pending'
        : status === 2
        ? 'Unapproval'
        : status === 1
        ? 'Approved'
        : 'Rejected'
    },
  },
}
</script>
